import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { setSeason } from "../../store/Uterum/UterumSlice";

import SeasonCard from "./SeasonCard";

import NavigateButton from "../../designComponents/NavigateButton/NavigateButton";
import SvgComponent from "../../components/SvgComponent/SvgComponent";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';

import {
  _Description as Description,
  _ChangeSeasonInfo as ChangeSeasonInfo,
} from "./SeasonViewStyle";

const SeasonView = () => {
  const dispatch = useDispatch();

  const init = useSelector((state) => state.init) || {};
  const { baseRoute, assetBaseUrl, alias } = init || {};
  
  let navigate = useNavigate();

  // On mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dispatch]);

  const seasons = [
    {
      name: alias.bfcSummer,
      value: "OPTIMAL",
      info: alias.bfcSeasonSummerInfo,
      iconName: "summer",
      period: alias.bfcSummerPeriod,
      shortDescription: alias.bfcSummerShortDescription,
    },
    {
      name: alias.bfcSpringFall,
      value: "ISOLENT",
      info: alias.bfcSeasonSpringFallInfo,
      iconName: "fall",
      period: alias.bfcSpringFallPeriod,
      shortDescription: alias.bfcSpringFallShortDescription,
    },
    {
      name: alias.bfcWinter,
      value: "ISOMAX",
      info: alias.bfcSeasonWinterInfo,
      iconName: "winter",
      period: alias.bfcWinterPeriod,
      shortDescription: alias.bfcWinterShortDescription,
    },
  ];
  
  const getObjectPosition = (season) => {
    switch (season) {
      case "OPTIMAL":
        return "100% 80%";
      case "ISOLENT":
        return "30% 50%";
      case "ISOMAX":
        return "0 80%";
      default:
        return "unset";
    }
  };
  
  return (
    <>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 3}}>
        <Typography variant='h1'>{alias.bfcSeasonHeading}</Typography>
        <Box sx={{maxWidth: '940px',mt:1, mb: 4}}>
          <Description>{alias.bfcSeasonIntroText}</Description>
        </Box>
      </Box>
      
      <Grid
        container
        spacing={{ xs: 3, lg: 4 }}
        mb={3}
      >
        {seasons.map((season) => (
          <SeasonCard
            imageSrc={`${assetBaseUrl}/store/Bfc_1.5/seasonImages/${season.value}.png`}
            key={season.value}
            imageTitle={season.value}
            objectPosition={getObjectPosition(season.value)}
          >
            <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '100%'}}>
              <Box sx={{display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px'}}>
                <SvgComponent name={season.iconName} />
                <Typography variant="h4">{season.name}</Typography>
              </Box>
            
              <Typography varian='body1'>
                {season.shortDescription}
              </Typography>
            </Box>

            {/* Button design component for consistent design and functionality */}
            <NavigateButton
              handleClick={() => {
                dispatch(setSeason(season.value));
                navigate(`../${baseRoute}/step2`);
              }}
              data-id={`Card__${season.value}__NavigateButton`}
              text={alias.bfcContinue}
              fontSize="14px"
              widthOnDesktop="100%"
            />
          </SeasonCard>
        ))}
    </Grid>

    <ChangeSeasonInfo>
      {alias.bfcChangeSeasonLater}
    </ChangeSeasonInfo>
    </>
  );
};

export default SeasonView;
